module.exports = function checkAllImages(self) {
  function isImageOk(img) {
    if (!img.complete) {
      return false;
    }

    if (typeof img.naturalWidth !== 'undefined' && img.naturalWidth === 0) {
      return false;
    }
    return true;
  }
  const images = document.querySelector('img');
  let imagesLoaded = 0;
  if (images && images.length) {
    const waitImages = setInterval(() => {
      imagesLoaded = 0;
      for (let img = 0; img < images.length; img += 1) {
        if (isImageOk(images[img])) imagesLoaded += 1;
      }
      if (imagesLoaded === images.length) {
        clearInterval(waitImages);
        self.$store.commit('LOADED_PAGE', true);
      }
    }, 50);
  }
};



// WEBPACK FOOTER //
// ./src/helpers/checkAllImages.js